module.exports = __webpack_public_path__ + "media/components/homepage/static/404-2f295eb040c0c507571ef01acf0a3d4b.jpg";